// "use strict";
// var twentyninetimes = twentyninetimes || {};

// twentyninetimes.blogFilter =
//   twentyninetimes.blogFilter ||
//   (function () {
//     function init() {
//       let filterItems = document.querySelectorAll(".blog-filter__item");
//       let postItems = document.querySelectorAll(".item-post");

//       if (filterItems) {
//         postItems.forEach((item, i) => {
//           setTimeout(() => {
//             item.classList.add("reveal-post");
//           }, i * 50);
//         });
//         filterItems.forEach((item) => {
//           item.addEventListener("click", function () {
//             const catId = this.getAttribute("data-cat-id");
//             history.pushState({}, "", `?cat_id=${catId}`);

//             postItems.forEach((item, i) => {
//               setTimeout(() => {
//                 item.classList.remove("reveal-post");
//               }, i * 50);
//             });


//             if (catId === null) {
//               fetch(ajaxurl, {
//                 method: "POST",
//                 headers: {
//                   "Content-Type": "application/x-www-form-urlencoded",
//                 },
//                 body: `action=filter_posts_by_category&cat_id=`,
//               })
//                 .then((response) => response.text())
//                 .then((data) => {
//                   document.querySelector(".loop__inner.row").innerHTML = data;
//                   postItems = document.querySelectorAll(".item-post");

//                   postItems.forEach((item, i) => {
//                     setTimeout(() => {
//                       item.classList.add("reveal-post");
//                     }, i * 50);
//                   });
//                 })
//                 .catch((error) => console.error("Error:", error));
//             } else {
//               fetch(ajaxurl, {
//                 method: "POST",
//                 headers: {
//                   "Content-Type": "application/x-www-form-urlencoded",
//                 },
//                 body: `action=filter_posts_by_category&cat_id=${catId}`,
//               })
//                 .then((response) => response.text())
//                 .then((data) => {
//                   document.querySelector(".loop__inner.row").innerHTML = data;
//                   postItems = document.querySelectorAll(".item-post");

//                   postItems.forEach((item, i) => {
//                     setTimeout(() => {
//                       item.classList.add("reveal-post");
//                     }, i * 50);
//                   });
//                 })
//                 .catch((error) => console.error("Error:", error));
//             }
//           }
//           );
//         });
//       }
//     }


//     // Tjek om url params eksisterer
//     document.addEventListener("DOMContentLoaded", function () {
//       let initialCatId = getQueryParam("cat_id");
//       if (initialCatId) {
//         fetch(ajaxurl, {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/x-www-form-urlencoded",
//           },
//           body: `action=filter_posts_by_category&cat_id=${initialCatId}`,
//         })
//           .then((response) => response.text())
//           .then((data) => {
//             document.querySelector(".loop__inner.row").innerHTML = data;

//             let postItems = document.querySelectorAll(".item-post");

//             postItems.forEach((item, i) => {
//               setTimeout(() => {
//                 item.classList.add("reveal-post");
//               }, i * 50);
//             });
//           })
//           .catch((error) => console.error("Error:", error));
//       }
//     });

//     function getQueryParam(name) {
//       let urlParams = new URLSearchParams(window.location.search);
//       return urlParams.get(name);
//     }

//     return {
//       // init: init,
//     };
//   })();
